<div class="organization-modal modal-content" piqetAngularDraggable>
  <div class="modal-header header-modal">
    <span class="bootstrap-dialog-title">{{ modalLabel }}</span>
    <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
      <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
    </button>
  </div>
  <div class="body-modal cutomBtn-margin">
    <form [formGroup]="testAutomationForm">
      <div class="row">
        <div class="col-sm-12">
          <piqet-angular-common-input
            formControlName="email"
            [control]="testAutomationForm.get('email')"
            label="Email"
            placeholder="Enter email"
            [submitted]="submitted"
            [inputType]="'email'"
            [errorMessages]="{
              required: 'Email is required.',
              pattern: 'Enter a valid email address.'
            }"
          >
          </piqet-angular-common-input>
        </div>
      </div>
    </form>
  </div>

  <div class="modal-footer">
    <button type="button" class="cancelBtn" (click)="onClose()">Cancel</button>
    <button
      type="button"
      class="modelBtn purpleBtnHoverEffect"
      [disabled]="testAutomationForm.invalid"
      (click)="onSave()"
    >
      Test
    </button>
  </div>
</div>
